import { Role } from './role.model';
import { Address } from './adress.model';
import { Enterprise, EntrepriseAddress, Representative } from './enterprise.model';
import { UserRoleEnum } from '../common/user-role.enum';
import { AssocUser } from './assoc-user.model';
import { UserDegree } from './user-degree.model';
import { UserSelfEmployed } from './user-self-employed.model';

export class User {

  private static _instance: User;

  id: number;
  auth_token: string;
  birth_date: string;
  // birth_date_ng: any;
  // budget: number;
  details: string;
  avatar: string;
  email: string;
  alt_email: string;
  facebook_token: string;
  firstname: string;
  username: string;
  image: string;
  is_active: boolean;
  name: string;
  password: string;
  password_confirmation: string;
  provider: string;
  role: Role;
  role_name: string;
  role_type: string;
  mangopay_user: boolean;
  participations_count: number;
  pots_count: number;

  // private properties
  user_adresses: Address;
  user_adress: Address;
  phone: string;
  fix_phone: string;
  mob_phone: string;

  training_impact?: boolean;
  commitment_signed?: boolean;
  stripe_customer_id?: string;

  // company properties
  enterprise_name: string;
  enterprise_number: string;
  entreprise: Enterprise;
  mangopay_user_id: string;
  mangopay_wallet_id: string;

  representative: Representative;
  assoc_user: AssocUser;
  degree: UserDegree;
  self_employed: UserSelfEmployed;
  user_roles: {
    role: Role;
  }

  static getPhone(input: User, type: string): string {
    let result = '';
    switch (input.role.id) {
      case UserRoleEnum.COMPANY:
        result = input.entreprise ? ('fix' === type ? input.entreprise.fix_phone :
          input.entreprise.mob_phone) : '';
        break;
      case UserRoleEnum.PRIVATE:
        result = input.entreprise ? ('fix' === type ? input.fix_phone :
          input.mob_phone) : '';
        break;
      case UserRoleEnum.MANAGER:
      case UserRoleEnum.ASSOCIATION:
        result = input.phone;
        break;
      default:
        break;
    }
    return result;
  }
}
